import { render } from "./PreferencesForm.vue?vue&type=template&id=154c1acc"
import script from "./PreferencesForm.vue?vue&type=script&lang=js"
export * from "./PreferencesForm.vue?vue&type=script&lang=js"

import exportComponent from "/Users/Teh/Dev/web/loop-client-dashboard/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__